import { render, staticRenderFns } from "./AscZoomChips.vue?vue&type=template&id=567bc0bb&"
import script from "./AscZoomChips.vue?vue&type=script&lang=js&"
export * from "./AscZoomChips.vue?vue&type=script&lang=js&"
import style0 from "./AscZoomChips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtnToggle})
